import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
export var GET_VENDOR_PLAN = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query vendorPlan($code: String!) {\n    vendorPlan(code: $code) {\n      code\n      price {\n        price\n        currency\n      }\n      availablePrices {\n        price\n        currency\n      }\n      billingType\n      billingPeriod\n      description\n      entitlements\n      experiment\n      id\n      name\n      family\n      trialPeriod\n      state\n    }\n  }\n"])));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/gql/queries.js
// module id = 5224
// module chunks = 11